import { createReducer, ActionType } from "typesafe-actions";
import * as actions from "./actions";
import initialState from "./state";
import { AssessmentState } from "./types";

type Action = ActionType<typeof actions>;

const reducer = createReducer<AssessmentState, Action>(
  initialState,
).handleAction(actions.setLanguage, (state, { payload }) => ({
  ...state,
  language: payload,
}));

export default reducer;
